export default function (state, getters) {
  if (!state.form.AgreementCodes.length) return false;
  let ag = getters['agreements/item'](state.form.AgreementCodes[0]);
  if (!ag) return false;
  let contragent = ag.contragents.filter(i => {
    return i.type === 7;
  })[0];
  if (!contragent) return false;
  return contragent.hiddenOperator;
}